import React from "react";

const SimpleModal = ({
  isOpen,
  onClose,
  children,
}: {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={handleOverlayClick}
    >
      <div
        className="relative bg-white rounded-lg shadow-xl w-fit max-w-[min(48rem,calc(100vw-2rem))] max-h-[min(90vh,720px)] flex flex-col overflow-hidden min-w-0"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="overflow-y-auto flex-1 min-h-0 min-w-0 w-full max-w-full p-4 sm:p-6">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SimpleModal;
